module.exports = __webpack_public_path__ + "static/media/clock.081c9b0f.svg";